import React from 'react';

const HealthZ = () => {
  return null;
};

export default HealthZ;
